var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHeaderLogo = function SvgHeaderLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 24,
    viewBox: "0 0 200 53.19",
    id: "Layer_2",
    "data-name": "Layer 2",
    className: "",
    style: {
      width: 140
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -4.08,
    y1: 17.39,
    x2: 54.01,
    y2: 17.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#01cdfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01acec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 26.53,
    x2: 54.01,
    y2: 26.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -4.08,
    y1: 26.53,
    x2: 54.01,
    y2: 26.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    y1: 35.5,
    x2: 54.01,
    y2: 35.5,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m94.25,53.19h0c-3.37,0-5.9-3.1-5.21-6.4l8.79-42.54c.51-2.47,2.69-4.25,5.21-4.25h0c3.37,0,5.9,3.1,5.21,6.4l-8.79,42.54c-.51,2.47-2.69,4.25-5.21,4.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m109.42,53.19h0c-3.35,0-5.85-3.07-5.18-6.35l6.05-29.26c.51-2.45,2.67-4.22,5.18-4.22h0c3.35,0,5.85,3.07,5.18,6.35l-6.05,29.26c-.51,2.45-2.67,4.22-5.18,4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m141.09,53.19h-7.01c-2.53,0-4.66-1.89-4.96-4.4l-3.55-29.84c-.35-2.97,1.97-5.58,4.96-5.58h1.59c2.59,0,4.76,1.99,4.98,4.57l2.12,25.01,13.28-26.81c.84-1.7,2.58-2.78,4.47-2.78h0c3.77,0,6.18,4.01,4.41,7.34l-15.88,29.84c-.87,1.63-2.56,2.65-4.41,2.65Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m85.43,7.53C81.44,2.51,75.44,0,67.42,0h-17.25C47.55,0,45.3,1.84,44.77,4.4h0c-.71,3.42,1.91,6.63,5.4,6.63h5.27s9.08,0,9.08,0c4.5,0,7.93,1.46,10.27,4.39,2.35,2.92,3.06,6.61,2.14,11.06-.93,4.5-3.15,8.24-6.67,11.22-3.48,2.94-7.36,4.43-11.65,4.46-.02,0-.04,0-.06,0h-17.1c-2.61,0-4.87,1.84-5.4,4.4h0c-.71,3.42,1.91,6.63,5.4,6.63h14.35c8.13,0,15.31-2.57,21.55-7.73,6.24-5.15,10.15-11.53,11.72-19.14,1.55-7.51.33-13.77-3.65-18.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m58.55,42.16s.04,0,.06,0c-.05,0-.09,0-.14,0h.08Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m50.47,19.77H13.8c-1.31,0-2.38-1.07-2.38-2.38s1.07-2.38,2.38-2.38h36.67c1.31,0,2.38,1.07,2.38,2.38s-1.07,2.38-2.38,2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m9.44,28.91H2.38c-1.31,0-2.38-1.07-2.38-2.38s1.07-2.38,2.38-2.38h7.06c1.31,0,2.38,1.07,2.38,2.38s-1.07,2.38-2.38,2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m39.05,28.91h-20.05c-1.31,0-2.38-1.07-2.38-2.38s1.07-2.38,2.38-2.38h20.05c1.31,0,2.38,1.07,2.38,2.38s-1.07,2.38-2.38,2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m46.98,37.88H10.08c-1.31,0-2.38-1.07-2.38-2.38s1.07-2.38,2.38-2.38h36.9c1.31,0,2.38,1.07,2.38,2.38s-1.07,2.38-2.38,2.38Z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeaderLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/header-logo.46bcb70d.svg";
export { ForwardRef as ReactComponent };